import {evenement} from "@/types/evenement";

export function findEvenement(
  day: Date,
  evenements?: evenement[],
): evenement[] {
  const evenementFinded: evenement[] = [];
  evenements?.forEach(event => {
    const eventDay = new Date(event.date);

    if (
      day.getDate() === eventDay.getDate() &&
      day.getMonth() === eventDay.getMonth() &&
      day.getFullYear() === eventDay.getFullYear()
    ) {
      evenementFinded.push(event);
    }
  });
  return evenementFinded;
}
